export const REQUEST_COLOR_TOKENS = Object.freeze([
  { token: 'NEUTRAL', label: 'Серый', light: { background: '#f3f4f6', border: '#9ca3af', text: '#111827' }, dark: { background: '#27272a', border: '#71717a', text: '#fafafa' } },
  { token: 'BLUE', label: 'Синий', light: { background: '#dbeafe', border: '#60a5fa', text: '#1e3a8a' }, dark: { background: '#172554', border: '#3b82f6', text: '#dbeafe' } },
  { token: 'CYAN', label: 'Бирюзовый', light: { background: '#cffafe', border: '#22d3ee', text: '#164e63' }, dark: { background: '#083344', border: '#06b6d4', text: '#cffafe' } },
  { token: 'GREEN', label: 'Зелёный', light: { background: '#dcfce7', border: '#4ade80', text: '#14532d' }, dark: { background: '#052e16', border: '#22c55e', text: '#dcfce7' } },
  { token: 'AMBER', label: 'Янтарный', light: { background: '#fef3c7', border: '#fbbf24', text: '#78350f' }, dark: { background: '#451a03', border: '#f59e0b', text: '#fef3c7' } },
  { token: 'ORANGE', label: 'Оранжевый', light: { background: '#ffedd5', border: '#fb923c', text: '#7c2d12' }, dark: { background: '#431407', border: '#f97316', text: '#ffedd5' } },
  { token: 'RED', label: 'Красный', light: { background: '#fee2e2', border: '#f87171', text: '#7f1d1d' }, dark: { background: '#450a0a', border: '#ef4444', text: '#fee2e2' } },
  { token: 'PURPLE', label: 'Фиолетовый', light: { background: '#f3e8ff', border: '#c084fc', text: '#581c87' }, dark: { background: '#3b0764', border: '#a855f7', text: '#f3e8ff' } },
])

const tokenMap = new Map(REQUEST_COLOR_TOKENS.map(item => [item.token, item]))

// Adjust these paired values to tune the Kanban WON/LOST title labels in both color schemes.
export const KANBAN_SYSTEM_COLUMN_LABEL_STYLES = Object.freeze({
  WON: {
    light: { background: '#d9f5dd', border: '#a9d5b0', text: '#187a36' },
    dark: { background: '#1d351d', border: '#273f27', text: '#53d769' },
  },
  LOST: {
    light: { background: '#f8d5d8', border: '#e9a7ae', text: '#b4232d' },
    dark: { background: '#441a1f', border: '#65252d', text: '#ff6b73' },
  },
})

export function requestColorStyles(token, mode = 'light') {
  if (!token) return null
  const entry = tokenMap.get(String(token).toUpperCase())
  return entry ? entry[mode === 'dark' ? 'dark' : 'light'] : null
}

export function kanbanSystemColumnLabelStyles(systemType, mode = 'light') {
  const scheme = mode === 'dark' ? 'dark' : 'light'
  return KANBAN_SYSTEM_COLUMN_LABEL_STYLES[systemType]?.[scheme] || null
}
